const ISSUANCE_ALERT_CONFIG_KEYS = [
  'issuanceTimeAlertEnabled',
  'issuanceTimeAlertCriticalMilliseconds',
  'issuanceTimeAlertCriticalSeconds',
  'issuanceTimeAlertTgChatId',
] as const;

export const ISSUANCE_ALERT_FIELDS = new Set<string>([
  'issuanceTimeAlertEnabled',
  'issuanceTimeAlertCriticalMilliseconds',
  'issuanceTimeAlertTgChatId',
]);

export function stripIssuanceAlertFromConfig(config: Record<string, unknown>): Record<string, unknown> {
  const result = {...config};
  for (const key of ISSUANCE_ALERT_CONFIG_KEYS) {
    delete result[key];
  }
  return result;
}

export function readIssuanceAlertFromLegacyConfig(config: Record<string, unknown>) {
  const enabled = config.issuanceTimeAlertEnabled;
  let milliseconds = config.issuanceTimeAlertCriticalMilliseconds;

  if (milliseconds == null && config.issuanceTimeAlertCriticalSeconds != null) {
    const seconds = Number(config.issuanceTimeAlertCriticalSeconds);
    if (!Number.isNaN(seconds)) {
      milliseconds = seconds * 1000;
    }
  }

  return {
    enabled: !!enabled,
    milliseconds: milliseconds != null ? Number(milliseconds) : null,
  };
}

export function getEffectiveIssuanceAlertChatId(
  storeChatId: string | null | undefined,
  merchantChatId: string | null | undefined,
): string {
  return (storeChatId?.trim() || merchantChatId?.trim() || '');
}
